export default __webpack_public_path__ + "static/media/Page_7.50737238.png";